import { useFieldValidationError } from 'components/common-form/hooks/useFieldValidationError';
import { ReactNode } from 'react';

import { ValidationFeedbackMessage } from './ValidationFeedbackMessage';

type ErrorWrapperProps<Form extends object = object> = {
  children: ReactNode;
  inputId: keyof Form extends string ? string : never;
  errorPrefix?: string;
};
export function FieldErrorWrapper<Form extends object = object>({
  inputId,
  children,
  errorPrefix,
}: ErrorWrapperProps<Form>) {
  const validationError = useFieldValidationError(inputId, errorPrefix);
  return (
    <>
      {children}
      <ValidationFeedbackMessage validationError={validationError} />
    </>
  );
}
